import { apiClient } from "../../base/ApiClient";


export const createRiskTypes = async (payload) => {
  const { data } = await apiClient.post("/careplan/api/risk-types/", payload);
  return data;
};

export const updateRiskType = async (id, payload) => {
  const { data } = await apiClient.put(`/careplan/api/risk-types/${id}/`, payload);
  return data;
};

export const deleteRiskType = async (id) => {
  const { data } = await apiClient.delete(`/careplan/api/risk-types/${id}/`);
  return data;
};

export const getRiskTypes = async (page = 1, pageSize = 10, all = false) => {
  const url = `/careplan/api/risk-types/?page=${page}&page_size=${pageSize}`;
  const { data } = await apiClient.get(url);
  return data;
};

export const getRisks = async (clientID, carePlanID) => {
  if (!clientID) throw new Error("clientID is required");
  
  const { data } = await apiClient.get(`/careplan/api/risks/`, {
    params: { 
      client: clientID,
      ...(carePlanID && { care_plan: carePlanID }) // Only adds the key if carePlanID exists
    },
  });
  return data;
};

export const createRisk = async (payload) => {
  const { data } = await apiClient.post("/careplan/api/risks/", payload);
  return data;
};

export const deleteRisk = async (id) => {
  const { data } = await apiClient.delete(`/careplan/api/risks/${id}/`);
  return data;
};
